import { render, staticRenderFns } from "./BodyDesigns.vue?vue&type=template&id=5a08c4a8&"
import script from "./BodyDesigns.vue?vue&type=script&lang=js&"
export * from "./BodyDesigns.vue?vue&type=script&lang=js&"
import style0 from "./BodyDesigns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a08c4a8')) {
      api.createRecord('5a08c4a8', component.options)
    } else {
      api.reload('5a08c4a8', component.options)
    }
    module.hot.accept("./BodyDesigns.vue?vue&type=template&id=5a08c4a8&", function () {
      api.rerender('5a08c4a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/BodyDesigns.vue"
export default component.exports